var module = angular.module('octopusApp.projects');

module.controller('ProjectTriggerEditController', function ($scope, busy, $stateParams, projectState, $location, $q, pageTitle, octopusRepository, unsavedChanges){

    var triggerId = $stateParams.triggerId;
    var projectId = $stateParams.projectId;
    var isLoading = $scope.isLoading = projectState.isLoading;
    var isSaving = $scope.isSaving = projectState.isSaving;

    if (!triggerId) {
        $scope.projectTrigger = {
            ProjectId: projectId,
            Name: "",
            Filter: {
                FilterType:"MachineFilter",
                EnvironmentIds:[],
                Roles:[],
                EventGroups:[],
                EventCategories:[]
            },
            Action: {
                ActionType:"AutoDeploy",
                ShouldRedeployWhenMachineHasBeenDeployedTo:false
            }
        };
    }
    $scope.actions = [];
    $scope.isMultiTenancyEnabled = false;
    $scope.teamSensitiveValues = { EnvironmentIds: [] };
    $scope.selectedFilters = {
        eventGroups: [],
        eventCategories: [],
        selectedEventGroupCategories: [],
        roles: [],
        environments: []
    };
    var unavailableEnvironments = [];

    function init() {
        var promises = [];

        promises.push(projectState.load().then(function (project) {
            $scope.project = project;
        }));

        promises.push(octopusRepository.MachineRoles.all().then(function (machineRoles) {
            $scope.roles = [];
            _.each(machineRoles, function (role) {
                $scope.roles.push({"Id":role, "Name":role});
            });
        }));

        promises.push(octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        }));

        promises.push(octopusRepository.Events.categories({appliesTo: "Machine"}).then(function (eventCategories) {
            $scope.eventCategories = eventCategories;
        }));

        promises.push(octopusRepository.Events.groups({appliesTo: "Machine"}).then(function (eventGroups) {
            $scope.eventGroups = eventGroups;
        }));

        isLoading.promises(promises).then(function(){
            if (triggerId) {
                isLoading.promise(octopusRepository.ProjectTriggers.get(triggerId)).then(function(projectTrigger) {
                    $scope.projectTrigger = projectTrigger;

                    $scope.selectedFilters.eventGroups = projectTrigger.Filter.EventGroups;
                    $scope.selectedFilters.eventCategories = projectTrigger.Filter.EventCategories;
                    $scope.selectedFilters.roles = projectTrigger.Filter.Roles;

                    var projectTriggerEnvironmentIds = projectTrigger.Filter.EnvironmentIds;

                    $scope.selectedFilters.environments = $scope.environments.filter(function(m){ return projectTriggerEnvironmentIds.indexOf(m.Id) !== -1; }).map(function(e){return e.Id;});
                    unavailableEnvironments = projectTriggerEnvironmentIds.filter(function(tid) { return $scope.selectedFilters.environments.indexOf(tid) === -1; });
                });
            }
        });
    }

    $scope.save = function() {
        $scope.projectTrigger.ProjectId = $scope.project.Id;
        $scope.projectTrigger.Filter.EnvironmentIds = ([].concat(unavailableEnvironments).concat($scope.selectedFilters.environments));
        $scope.projectTrigger.Filter.EventGroups = $scope.selectedFilters.eventGroups;
        $scope.projectTrigger.Filter.EventCategories = $scope.selectedFilters.eventCategories;
        $scope.projectTrigger.Filter.Roles = $scope.selectedFilters.roles;

        isSaving.promise(octopusRepository.ProjectTriggers.save($scope.projectTrigger).then(function() {
            unsavedChanges.saved();
            $location.path('/projects/' + $scope.project.Slug + '/triggers');
        }));
    };

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/triggers/project_trigger_edit_controller.js
// module id = 5868416072229749
// module chunks = 1